"use client";

import Link from "next/link";

import { useCurrentUser } from "@/hooks/use-current-user";
import { useSidebarBanner } from "@/hooks/use-sidebar-banner";
import { isExternalBannerUrl } from "@/lib/banner/types";

export function SidebarBanner() {
  const currentUserQuery = useCurrentUser();
  const enabled = currentUserQuery.data?.accountStatus === "active";
  const bannerQuery = useSidebarBanner(Boolean(enabled));
  const banner = bannerQuery.data;

  if (!banner?.imageUrl) {
    return null;
  }

  const className =
    "block overflow-hidden rounded-2xl border bg-muted/30 shadow-[0_1px_2px_rgba(16,24,40,0.04)] transition hover:opacity-95";
  const image = (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src={banner.imageUrl}
      alt={banner.altText || "Banner"}
      className="aspect-[4/5] w-full object-cover"
    />
  );

  if (isExternalBannerUrl(banner.targetUrl)) {
    return (
      <div className="p-3 pb-5">
        <a
          href={banner.targetUrl}
          target="_blank"
          rel="noreferrer"
          className={className}
        >
          {image}
        </a>
      </div>
    );
  }

  return (
    <div className="p-3 pb-5">
      <Link href={banner.targetUrl} className={className}>
        {image}
      </Link>
    </div>
  );
}
